import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Building } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-24 bg-[#FAF9F7]" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-58">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-59">
            <h2 className="text-3xl md:text-4xl font-bold text-[#800000] font-serif mb-8" data-id="element-60">
              Get in touch with us!
            </h2>

            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100" data-id="element-61">
              <h3 className="text-2xl font-bold text-gray-900 font-serif mb-2" data-id="element-62">
                Dr. Arvind Pattamatta
              </h3>
              <p className="text-[#800000] font-medium mb-8" data-id="element-63">Professor</p>

              <div className="space-y-6" data-id="element-64">
                <div className="flex items-start gap-4" data-id="element-65">
                  <div className="mt-1 bg-[#FAF9F7] p-2 rounded-full text-[#800000]" data-id="element-66">
                    <Building size={20} data-id="element-67" />
                  </div>
                  <div data-id="element-68">
                    <p className="text-gray-900 font-medium" data-id="element-69">
                      Multiscale Thermal Transport Research Lab
                    </p>
                    <p className="text-gray-600" data-id="element-70">
                      Department of Mechanical Engineering
                    </p>
                    <p className="text-gray-600" data-id="element-71">
                      Indian Institute of Technology Madras
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-72">
                  <div className="mt-1 bg-[#FAF9F7] p-2 rounded-full text-[#800000]" data-id="element-73">
                    <MapPin size={20} data-id="element-74" />
                  </div>
                  <div data-id="element-75">
                    <p className="text-gray-600" data-id="element-76">Chennai 600 036</p>
                    <p className="text-gray-600" data-id="element-77">Room # HTTP 104</p>
                  </div>
                </div>

                <div className="flex items-center gap-4" data-id="element-78">
                  <div className="bg-[#FAF9F7] p-2 rounded-full text-[#800000]" data-id="element-79">
                    <Phone size={20} data-id="element-80" />
                  </div>
                  <p className="text-gray-600" data-id="element-81">+91 44 2257 4654(O)</p>
                </div>

                <div className="flex items-center gap-4" data-id="element-82">
                  <div className="bg-[#FAF9F7] p-2 rounded-full text-[#800000]" data-id="element-83">
                    <Mail size={20} data-id="element-84" />
                  </div>
                  <a href="mailto:arvindp@iitm.ac.in" className="text-[#800000] hover:underline font-medium" data-id="element-85">
                    arvindp@iitm.ac.in
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Decorative Map / Image Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative h-[500px] rounded-2xl overflow-hidden shadow-lg" data-id="element-86">
            <img src="https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="IIT Madras Campus" className="w-full h-full object-cover" data-id="element-87" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#800000]/80 to-transparent flex items-end p-8" data-id="element-88">
              <div className="text-white" data-id="element-89">
                <h4 className="text-xl font-bold font-serif mb-2" data-id="element-90">
                  IIT Madras Campus
                </h4>
                <p className="text-white/80 text-sm" data-id="element-91">
                  Nestled in a lush green campus in the heart of Chennai.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}